import SaveIcon from './component'

export default SaveIcon
